import React from 'react'
import Nav from './Nav'
import Hero from './Hero'
import Collection from './Collection'
import Footer from './Footer'
import InfiniteMovingCards from './InfiniteCards'
import { Link } from 'react-router-dom'
import Logo from "./Logo";
import "../styles/Nav.css";
import {
  FaCheck,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaStar,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa6";
const Main = () => {
  return (
    <div className='flex-col items-center justify-center'>
        <Nav/>
        <Hero/>
        <InfiniteMovingCards/>
        <Collection />
        {/* <Footer /> */}
        <footer className="border-t-2 border-gray-500 py-4 text-center px-2 ">
        <div className="flex flex-col md:flex-row items-center justify-between mx-8">
          <Link to="/" className="m-3 hidden sm:block">
            <Logo />
          </Link>

          <p className="mx-4">
            &copy; 2025 Karishma's Closet. <br /> All rights reserved.
          </p>

          {/* Social Media Icons */}
          <div className="flex space-x-4">
            <a href="https://wa.me/" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp size={24} className="hover:text-green-700" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={24} className="hover:text-purple-800" />
            </a>
            <a
              href="mailto:example@example.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope size={24} className="hover:text-gray-900" />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={24} className="hover:text-blue-800" />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter size={24} className="hover:text-blue-600" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Main
